import React, { useState } from 'react';
import CustomTh from '../../../../../components/table/CustomTh';
import CustomTd from '../../../../../components/table/CustomTd';
import dayId from '../../../../../hooks/dayId';
import { TrashOutlineIcon} from '../../../../../components/buttons/IconButtons';
import {useTranslation} from 'react-i18next';
import ButtonIcon from '../../../../../components/buttons/ButtonIcon';

const CustomizedTable = ({ data, handleRemoveAccess }) => {
    const { t } = useTranslation();
    const [tableId, setTableId] = useState("tbl_awst_table");
    const [searchId, setSearchId] = useState("tbl_awst_search_id");

    const getThead = () => {
        let header = [
            <CustomTh tableId={tableId} classes="first_head">{t('zones')}</CustomTh>,
            <CustomTh tableId={tableId} >{t('day')}</CustomTh>,
            <CustomTh tableId={tableId} >{t('from')}</CustomTh>,
            <CustomTh tableId={tableId} >{t('to')}</CustomTh>
        ];
        return header;
    }

    const getTbody = () => {
        if (!data || data?.length === 0) return {
            body: [],
            data: []
        };
        let body = data?.map(item => {
            return (
                <>
                    <CustomTd tableId={tableId} classes={"first-column"} >{item?.zoneName || '-'}</CustomTd>
                    <CustomTd tableId={tableId} >{item?.dayId !== '' ? dayId(item?.dayId) : '-'}</CustomTd>
                    <CustomTd tableId={tableId} >{item?.from || '-'}</CustomTd>
                    <CustomTd tableId={tableId} >{item?.to || '-'}</CustomTd>
                </>
            );
        });

        return {
            body: body,
            data: data
        }
    };

    const getActionsButtons = (item, index) => {
        return <ButtonIcon
            id='btn_ct_all_delete'
            Icon={TrashOutlineIcon}
            onClick={() => {
                handleRemoveAccess(index);
            }}
            title={'delete'}
            className='btn-background-transparent'
            iconProps={'btn-icon-svg-18px btn-icon-svg-red'}
        />
    }

    return {
        tableId,
        searchId,
        thead: getThead(),
        tbody: getTbody(),
        getActionsButtons
    };

}
export default CustomizedTable;
